import { useEventListener } from '@vueuse/core';
import { setValueToLocalStorage } from '@/js/quests/game/helpers/localStorageHelper';

enum sidebarControlClass {
    SIDEBAR_ON = 'sidebar-on',
    SIDEBAR_OFF = 'sidebar-off',
    CARET_LEFT = 'fa-square-caret-left',
    CARET_RIGHT = 'fa-square-caret-right',
}

const FALSE = 'false';
const TRUE = 'true';
const SIDEBAR_KEY = 'cryptoBookSidebarToggle';

function closeSidebar(sidebar: HTMLElement, sidebarToggle: HTMLElement) {
    sidebar.classList.remove(sidebarControlClass.SIDEBAR_ON);
    sidebar.classList.add(sidebarControlClass.SIDEBAR_OFF);
    sidebarToggle.classList.remove(sidebarControlClass.CARET_LEFT);
    sidebarToggle.classList.add(sidebarControlClass.CARET_RIGHT);
}

function openSidebar(sidebar: HTMLElement, sidebarToggle: HTMLElement) {
    sidebar.classList.remove(sidebarControlClass.SIDEBAR_OFF);
    sidebar.classList.add(sidebarControlClass.SIDEBAR_ON);
    sidebarToggle.classList.remove(sidebarControlClass.CARET_RIGHT);
    sidebarToggle.classList.add(sidebarControlClass.CARET_LEFT);
}

function toggleDesktopSidebar(sidebar: HTMLElement, sidebarToggle: HTMLElement) {
    if (sidebar.classList.contains(sidebarControlClass.SIDEBAR_ON)) {
        closeSidebar(sidebar, sidebarToggle);
        setValueToLocalStorage(SIDEBAR_KEY, FALSE);
    } else {
        openSidebar(sidebar, sidebarToggle);
        setValueToLocalStorage(SIDEBAR_KEY, TRUE);
    }
}

const initializeSidebar = () => {
    const sidebar: HTMLElement = document.getElementById('sidebar');
    const sidebarToggle = document.getElementById('sidebar-toggle');

    const isSidebarClosed = localStorage.getItem(SIDEBAR_KEY) === FALSE;

    if (sidebarToggle && sidebar) {
        if (isSidebarClosed) {
            closeSidebar(sidebar, sidebarToggle);
        } else {
            openSidebar(sidebar, sidebarToggle);
        }

        useEventListener(sidebarToggle, 'click', () => toggleDesktopSidebar(sidebar, sidebarToggle));
    }
};

useEventListener(document, 'DOMContentLoaded', initializeSidebar);
